import { send } from 'ms-email/api/send-map-guest-invitation'
import { useDispatch } from 'react-redux'
import { baseUrl, getInviteLink, getMapLink } from 'utils'
import { createMapAccess } from '~map-preview/api/createMapAccess'
import { useGetMapById } from '~map-preview/queries/useGetMapById'
import { useMap } from '~map-preview/states/map'
import { closeInviteGuestDrawer } from '~map-preview/states/ui'
import { useAuth } from '~user-auth/contexts/auth'

export const useInviteUserToMapByEmail = () => {
  const dispatch = useDispatch()
  const map = useMap()
  const { refetch } = useGetMapById(map.id)
  const { user } = useAuth()

  const invite = async (email: string) => {
    if (!map || !Object.keys(map).length) throw new Error('Map not found')

    if (!map.isPublic) {
      await createMapAccess({ email, mapId: map.id })
      await refetch()

      const inviteUrl = `${getInviteLink({
        workspaceId: map.workspace.id,
        workspaceName: map.workspace.name,
        inviteId: map.workspace.inviteId
      })}&redirect=${encodeURIComponent(
        getMapLink({ mapId: map.id, mapName: map.name })
      )}`

      send(
        {
          map,
          user,
          inviteUrl
        },
        [email]
      )
    } else {
      send(
        {
          map,
          user,
          inviteUrl:
            baseUrl() + getMapLink({ mapId: map.id, mapName: map.name })
        },
        [email]
      )
    }

    dispatch(closeInviteGuestDrawer())
  }

  return { invite }
}
